import { Directive, TemplateRef, OnDestroy, AfterContentInit } from '@angular/core';
import { AppTemplateService } from './apptemplate.service';

@Directive({
    selector: '[appTemplate]'
})
export class AppTemplateDirective implements OnDestroy, AfterContentInit {

    constructor(private sts: AppTemplateService, private tr: TemplateRef<any>) {
    }

    ngAfterContentInit() {
        this.sts.TemplateChanged.next(this.tr);
    }

    ngOnDestroy() {
        this.sts.TemplateChanged.next(null);
    }
}
